import moment from 'moment-timezone';
export const GET_RECORDINGS_REQUEST = 'GET_RECORDINGS_REQUEST';
export const GET_RECORDINGS_FAILURE = 'GET_RECORDINGS_FAILURE';
export const GET_RECORDINGS_SUCCESS = 'GET_RECORDINGS_SUCCESS';
export const TOGGLE_RECORDING = 'TOGGLE_RECORDING';
export const TOGGLE_ALL_RECORDINGS = 'TOGGLE_ALL_RECORDINGS';
export const FILTER_RECORDINGS_BY_COUNT_REQUEST = 'FILTER_RECORDINGS_BY_COUNT_REQUEST';
export const FILTER_RECORDINGS_BY_COUNT = 'FILTER_RECORDINGS_BY_COUNT';
export const RECORDINGS_POST_UNIQUE_TABLE_ID = 'RECORDINGS_POST_UNIQUE_TABLE_ID';

export function getRecordings(
  fromTime = moment()
    .subtract(6, 'month')
    .toISOString(),
  toTime = moment().toISOString()
) {
  return {
    type: GET_RECORDINGS_REQUEST,
    payload: { fromTime, toTime }
  };
}

export function toggleRecording(recordingKey, isSelected, uniqueTableId) {
  return {
    type: TOGGLE_RECORDING,
    payload: { recordingKey, isSelected, uniqueTableId }
  };
}

export function toggleAllRecordings(isSelected = true, uniqueTableId) {
  return {
    type: TOGGLE_ALL_RECORDINGS,
    payload: { isSelected, uniqueTableId }
  };
}

export function filterRecordingsByCount(filterOptions) {
  let { viewsRange, sharesRange, searchString, sources } = filterOptions;

  return {
    type: FILTER_RECORDINGS_BY_COUNT_REQUEST,
    payload: { viewsRange, sharesRange, searchString, sources }
  };
}

export function postRecordingsTableId(uniqueTableId) {
  return {
    type: RECORDINGS_POST_UNIQUE_TABLE_ID,
    payload: { uniqueTableId }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/Recordings/RecordingsActions.js